module.exports = __webpack_public_path__ + "static/musa-dbeb0b5d4ad11275b6591519fc6c101f.png";